import "./style.css";
import "./setup.css";
import "./game.css";
import "./gameboard.css";
import "./setupBoard.css";

import initSetup from "./setupController.js";

initSetup();
